import {ChangeDetectorRef, Component, Input, OnChanges} from "@angular/core";

@Component({
    selector: "woa-icon",
    templateUrl: "./icon.component.html"
})
export class IconComponent implements OnChanges {
    @Input() name: string;
    @Input() grunge: boolean;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/icon/icon.component.ts